import React from 'react';

// tslint:disable:max-line-length

export const BenefitsIcon = () => (
  <svg width="96" height="96" viewBox="0 0 96 96">
    <defs>
      <circle id="spot_calendar_md-a" cx="48.28" cy="47.72" r="47.72" />
    </defs>
    <g fill="none" fill-rule="evenodd">
      <use fill="#F8F8F8" xlinkHref="#spot_calendar_md-a" />
      <path
        fill="#CCC"
        d="M25.9050743,24 C25.9050743,24 24,24 24,25.8202971 L24,73.1797029 C24,73.1797029 24,75 25.9050743,75 L74.0949257,75 C74.0949257,75 76,75 76,73.1797029 L76,25.8202971 C76,25.8202971 76,24 74.0949257,24 L25.9050743,24 Z"
      />
      <path
        fill="#FFF"
        d="M22.9044716,21 C22.9044716,21 21,21 21,22.8202971 L21,22.8202971 L21,70.1797029 C21,70.1797029 21,72 22.9044716,72 L22.9044716,72 L71.0946243,72 C71.0946243,72 73,72 73,70.1797029 L73,70.1797029 L73,22.8202971 C73,22.8202971 73,21 71.0946243,21 L71.0946243,21 L22.9044716,21 Z"
      />
      <path
        fill="#FA4616"
        d="M71.0946243,21 C72.6597543,21 72.9392418,22.2282362 72.9891503,22.6668919 L73,22.8202971 L73,32 L21,32 L21,22.8202971 L21.007114,22.6321477 C21.1242348,21.1208998 22.6511435,21.0089555 22.8767096,21.0006634 L71.0946243,21 Z"
      />
      <polygon fill="#ABABAB" points="49 44 56 44 56 37 49 37" />
      <polygon fill="#ABABAB" points="48.987 55 55.987 55 55.987 48 48.987 48" />
      <polygon fill="#ABABAB" points="49 66 56 66 56 59 49 59" />
      <polygon fill="#ABABAB" points="60 44 67 44 67 37 60 37" />
      <polygon fill="#ABABAB" points="60 55 67 55 67 48 60 48" />
      <polygon fill="#ABABAB" points="60 66 67 66 67 59 60 59" />
      <polygon fill="#ABABAB" points="38 44 45 44 45 37 38 37" />
      <polygon fill="#ABABAB" points="38 55 45 55 45 48 38 48" />
      <polygon fill="#ABABAB" points="38 66 45 66 45 59 38 59" />
      <polygon fill="#ABABAB" points="27 44 34 44 34 37 27 37" />
      <polygon fill="#ABABAB" points="27 55 34 55 34 48 27 48" />
      <polygon fill="#ABABAB" points="27 66 34 66 34 59 27 59" />
      <polygon fill="#505050" points="62 26 66 26 66 15 62 15" />
      <polygon fill="#505050" points="28 26 32 26 32 15 28 15" />
    </g>
  </svg>
);
